export const validationTypes = {
    REQUIRE: "require",
    EMAIL: "email",
    NOWHITESPACE: "noWhitespace",
    PASSWORD: "password",
    PHONENUMBER: "phoneNumber",
    COMPARE: "compare",
    DISTINICT: "distinct",
    NUMBER: "number",
    UNIQUEIDENTIFIER: "uniqueIdentifier",
    MAXLENGTH: "maxLength",
    MINLENGTH: "minLength",
    MAXPROSPECTS: "maxProspects",
    MINENDDATE: "minEndDate",
    MAXSUM: "maxSum",
    VALIDEIN: "validEIN",
    VALIDPHONE: "validPhone",
    VALIDFAX: "validFax",
    FILE: "file",
    IMAGE: "image",
}
